import { useMemo } from "react";
import * as yup from "yup";

export const useTagSchema = () => {
  return useMemo(() => {
    const facilityIdsSchema = yup
      .array()
      .of(yup.string())
      .min(1, "At least one facility is required")
      .required("At least one facility is required");

    return yup.object({
      tagName: yup.string().optional(),
      newTagName: yup
        .string()
        .typeError("Tag name is required")
        .required("Tag name is required"),
      facilityIds: facilityIdsSchema,
    });
  }, []);
};
